import { getBrowserSupportKey } from '../../components/utils/Helper';

/**
 * This hook exists so we can use launch darkly flags in one central location
 * for browser support
 */
export const useBrowserSupport = () => {
  const scenario = getBrowserSupportKey();
  const supportedBrowser = !scenario;
  return { supportedBrowser, scenario };
};
